module.exports = "/images/mail.svg?d0e7ad71bef186c622d8feb84c1ccc53";